import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-response-popup',
  template: `
    <div class="response-popup">
      <div class="response-popup__body" *ngIf="config.data.messageHtml" [innerHtml]="config.data.messageHtml"></div>
      <p class="response-popup__message" *ngIf="config.data.message">
        <i class="response-popup__icon" [class]="config.data.icon" [ngStyle]="{ color: config.data.color }"></i>
        <span>{{ config.data.message }}</span>
      </p>
      <div class="response-popup__footer">
        <button pButton label="Close" class="primary-button" [severity]="'primary'" icon="pi pi-times" (click)="ref.close()"></button>
      </div>
    </div>
  `,
  styles: [`
    .response-popup {
      color: #0f172a;
      background: #ffffff;
      box-sizing: border-box;
    }

    .response-popup__icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: none;
      width: 2rem;
      height: 2rem;
      border-radius: 9px;
      font-size: 1rem;
    }

    .response-popup__body {
      max-height: 68vh;
      overflow-y: auto;
      overscroll-behavior: contain;
      padding-right: 0.35rem;
    }

    .response-popup__body::-webkit-scrollbar {
      width: 6px;
    }

    .response-popup__body::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 99px;
    }

    .response-popup__message {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin: 0 0 0.5rem;
      color: #334155;
      line-height: 1.6;
    }

    .response-popup__footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 1rem;
      padding-top: 0.85rem;
      border-top: 1px solid #e2e8f0;
    }

    :host ::ng-deep {
      .lm-detail {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }

      .lm-detail__hero {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 1rem;
        padding: 1rem 1.25rem;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
      }

      .lm-detail__hero-left {
        display: flex;
        align-items: center;
        gap: 0.85rem;
      }

      .lm-detail__avatar {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background: #1D4370;
        color: #ffffff;
        font-size: 0.95rem;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        box-shadow: 0 4px 10px rgba(29, 67, 112, 0.22);
      }

      .lm-detail__hero-info {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
      }

      .lm-detail__name,
      .lm-detail__name.sub-title-h2 {
        margin: 0;
        font-size: 1.15rem;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.25;
      }

      .lm-detail__role {
        margin: 0;
        font-size: 0.78rem;
        color: #64748b;
        font-weight: 500;
      }

      .lm-detail__hero-right {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        flex-wrap: wrap;
      }

      .lm-detail__badge-sku {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        padding: 0.28rem 0.65rem;
        border-radius: 999px;
        font-size: 0.74rem;
        font-weight: 700;
        background: #eff6ff;
        border: 1px solid #bfdbfe;
        color: #1d4ed8;

        &.lm-pill--starter  { background: #eff6ff; border-color: #bfdbfe; color: #1d4ed8; }
        &.lm-pill--standard { background: #eef2ff; border-color: #c7d2fe; color: #4338ca; }
        &.lm-pill--frontline{ background: #ecfdf5; border-color: #a7f3d0; color: #047857; }
        &.lm-pill--plus     { background: #faf5ff; border-color: #e9d5ff; color: #7e22ce; }
        &.lm-pill--lite     { background: #f8fafc; border-color: #e2e8f0; color: #475569; }
        &.lm-pill--archived { background: #fff7ed; border-color: #ffedd5; color: #c2410c; }
        &.lm-pill--vault    { background: #fffbeb; border-color: #fde68a; color: #b45309; }
        &.lm-pill--none     { background: #f1f5f9; border-color: #cbd5e1; color: #64748b; }
      }

      .lm-detail__badge-status {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        padding: 0.28rem 0.65rem;
        border-radius: 999px;
        font-size: 0.74rem;
        font-weight: 700;

        &--active {
          background: #ecfdf5;
          border: 1px solid #a7f3d0;
          color: #047857;
          .lm-detail__status-dot {
            background: #10b981;
            box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.25);
          }
        }

        &--inactive {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          color: #64748b;
          .lm-detail__status-dot {
            background: #94a3b8;
          }
        }
      }

      .lm-detail__status-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
      }

      .lm-detail__strip {
        display: flex;
        align-items: center;
        gap: 0.65rem 1.25rem;
        flex-wrap: wrap;
        padding: 0.55rem 0.95rem;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        font-size: 0.77rem;
        color: #475569;
      }

      .lm-detail__strip-item {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;

        i {
          font-size: 0.75rem;
          color: #1D4370;
        }

        strong {
          color: #0f172a;
        }
      }

      .lm-detail__grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 0.85rem;
      }

      .lm-detail__card {
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        padding: 0.85rem 1rem;
        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03);
      }

      .lm-detail__card-head {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding-bottom: 0.65rem;
        margin-bottom: 0.65rem;
        border-bottom: 1px solid #f1f5f9;
      }

      .lm-detail__card-icon {
        width: 26px;
        height: 26px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.75rem;

        &--blue   { background: #eff6ff; color: #1d4ed8; }
        &--teal   { background: #f0fdfa; color: #0d9488; }
        &--purple { background: #f5f3ff; color: #7c3aed; }
      }

      .lm-detail__card-title,
      .lm-detail__card-title.sub-title-h2 {
        margin: 0;
        font-size: 0.8rem;
        font-weight: 700;
        color: #0f172a;
        text-transform: uppercase;
        letter-spacing: 0.03em;
      }

      .lm-detail__fields {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }

      .lm-detail__row {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
      }

      .lm-detail__label {
        font-size: 0.68rem;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;

        i {
          font-size: 0.65rem;
          color: #94a3b8;
        }
      }

      .lm-detail__value {
        font-size: 0.82rem;
        color: #0f172a;
        line-height: 1.35;
        overflow-wrap: anywhere;

        &--mono {
          font-family: 'Reddit Sans', sans-serif;
          font-size: 0.76rem;
          color: #334155;
        }
      }

      .lm-detail__code {
        font-family: 'Reddit Sans', sans-serif;
        font-size: 0.72rem;
        background: #f1f5f9;
        border: 1px solid #e2e8f0;
        padding: 0.1rem 0.35rem;
        border-radius: 4px;
        color: #334155;

        &--lg {
          font-size: 0.8rem;
          font-weight: 700;
          color: #1D4370;
          background: #eff6ff;
          border-color: #bfdbfe;
        }
      }

      .lm-detail__pill {
        display: inline-flex;
        align-items: center;
        padding: 0.15rem 0.55rem;
        border-radius: 999px;
        font-size: 0.72rem;
        font-weight: 700;

        &.lm-pill--starter  { background: #eff6ff; border: 1px solid #bfdbfe; color: #1d4ed8; }
        &.lm-pill--standard { background: #eef2ff; border: 1px solid #c7d2fe; color: #4338ca; }
        &.lm-pill--frontline{ background: #ecfdf5; border: 1px solid #a7f3d0; color: #047857; }
        &.lm-pill--plus     { background: #faf5ff; border: 1px solid #e9d5ff; color: #7e22ce; }
        &.lm-pill--lite     { background: #f8fafc; border: 1px solid #e2e8f0; color: #475569; }
        &.lm-pill--archived { background: #fff7ed; border: 1px solid #ffedd5; color: #c2410c; }
        &.lm-pill--vault    { background: #fffbeb; border: 1px solid #fde68a; color: #b45309; }
        &.lm-pill--none     { background: #f1f5f9; border: 1px solid #cbd5e1; color: #64748b; }
      }

      .lm-detail__status-tag {
        display: inline-flex;
        align-items: center;
        gap: 0.3rem;
        padding: 0.15rem 0.5rem;
        border-radius: 999px;
        font-size: 0.71rem;
        font-weight: 700;

        &--on {
          background: #ecfdf5;
          border: 1px solid #a7f3d0;
          color: #047857;
        }

        &--off {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          color: #64748b;
        }

        i { font-size: 0.65rem; }
      }

      .lm-detail__link {
        color: #0284c7;
        text-decoration: none;
        font-weight: 600;

        &:hover {
          color: #0369a1;
          text-decoration: underline;
        }
      }

      .lm-detail__footer-note {
        display: flex;
        align-items: center;
        gap: 0.45rem;
        padding: 0.5rem 0.85rem;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        font-size: 0.72rem;
        color: #64748b;

        i {
          color: #10b981;
          font-size: 0.8rem;
        }
      }
    }
  `],
  standalone: true,
  imports: [CommonModule, ButtonModule],
})
export class ResponsePopupComponent {
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}
}